import { render, staticRenderFns } from "./Tapper.vue?vue&type=template&id=2a893b02&scoped=true"
import script from "./Tapper.vue?vue&type=script&lang=js"
export * from "./Tapper.vue?vue&type=script&lang=js"
import style0 from "./Tapper.vue?vue&type=style&index=0&id=2a893b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a893b02",
  null
  
)

export default component.exports